// extracted by mini-css-extract-plugin
module.exports = {"videoList":"video_videoList__hxvq7","adsItem":"video_adsItem__9eLMF","link":"video_link__YHEHD"};